<template>
<div>
    <div class="vx-card">
        <div class="vx-card__header">
            <div class="vx-card__title">
                <h4 class>Facturation</h4>
            </div>
        </div>

        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <!-- Content Row -->
                <div class="w-full">
                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Marge</label>

                                <div class="mt-2">
                                    <vs-input v-model="infoFournissseur.marge" class="w-full" icon-pack="feather" icon="icon-edit" name="code" />
                                    <span class="text-danger text-sm" v-show="errors.has('code')">{{ errors.first('code') }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Remise</label>

                                <div class="mt-2">
                                    <vs-input class="w-full" v-model="infoFournissseur.remise" icon-pack="feather" icon="icon-edit" v-validate="'required'" name="designation" />
                                    <span class="text-danger text-sm" v-show="errors.has('designation')">{{ errors.first('designation') }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Save & Reset Button -->
                    </div>

                </div>

            </div>
        </div>

        <div class="vx-card__header">
            <div class="vx-card__title">
                <h4 class>Paiement</h4>
            </div>
        </div>

        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <!-- Content Row -->
                <div class="w-full">

                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">ConditionPaiement / Délais *</label>

                                <div class="mt-2">
                                    <v-select class="w-full" v-model="infoFournissseur.delaisPaiment" :options="optionsDelais" />
                                </div>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary  px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Mode de Réglement/paiement</label>
                                <div class="mt-2 vx-col">

                                    <div class="mt-2">
                                        <vs-checkbox v-model="infoFournissseur.modePaiCheque">Chèque</vs-checkbox>
                                    </div>
                                    <div class="mt-2">
                                        <vs-checkbox v-model="infoFournissseur.modePaiTraite">Traite</vs-checkbox>

                                    </div>
                                    <div class="mt-2 vx-col">
                                        <label class="ml-2">Autre</label>
                                        <vs-input v-model="infoFournissseur.modePaiAutre" icon-pack="feather" icon="icon-edit" />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>

                    </div>

                </div>

            </div>
        </div>
    </div>
</div>
</template>

<script>
import vSelect from "vue-select";

export default {
    props: {
        infoFournissseur: {
            type: Object
        }
    },
    data() {
        return {
            optionsDelais: [{
                id: "Comptant",
                label: "Comptant"
            }, {
                id: "30J",
                label: "30J"
            }, {
                id: "60J",
                label: "60J"
            }, {
                id: "90J",
                label: "90J"
            }, {
                id: "120J",
                label: "120J"
            }, {
                id: "150j",
                label: "150J"
            }, ]
        }
    },
    methods: {
        tabSuivant() {
            this.$emit("activeTab", 3);
        }
    },
    components: {
        vSelect
    },
    created() {
        this.$emit('updatePage', 2)
    }
}
</script>

<style>

</style>
